import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { usePurchaseOrderMainCommentCreate } from '@/features/purchase-order/hooks/use-purchase-order-main-comment-create';
import { PurchaseOrderMainCommentForm } from '@/features/purchase-order/purchase-order-main-comment-form';

type PurchaseOrderMainCommentCreateProps = {
  purchaseOrderId: string;
  open: boolean;
  setOpen: (value: boolean) => void;
};

export function PurchaseOrderMainCommentCreate({
  purchaseOrderId,
  open,
  setOpen,
}: PurchaseOrderMainCommentCreateProps) {
  const { t } = useTranslation('purchaseOrder');
  const { control, handleSubmit, onSubmit, isSubmitting, resetToEmpty } =
    usePurchaseOrderMainCommentCreate({ purchaseOrderId, setOpen });

  const onOpenChange = (nextOpen: boolean) => {
    if (isSubmitting) {
      return;
    }
    setOpen(nextOpen);
    if (!nextOpen) {
      resetToEmpty();
    }
  };

  return (
    <Dialog onOpenChange={onOpenChange} open={open}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t('Create comment')}</DialogTitle>
          <DialogDescription />
        </DialogHeader>
        <PurchaseOrderMainCommentForm
          control={control}
          handleSubmit={handleSubmit}
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
        >
          <DialogClose asChild>
            <Button disabled={isSubmitting} type='button' variant='outline'>
              {t('cancel', { ns: 'common' })}
            </Button>
          </DialogClose>
        </PurchaseOrderMainCommentForm>
      </DialogContent>
    </Dialog>
  );
}
